/**
 * True when the browser implements `<input type="date">` natively.
 *
 * Safari on macOS only gained native date inputs in 14.1 (April 2021); before that
 * the element silently degrades to a plain text field. Detecting that explicitly
 * means the fallback is a path we control — numeric keypad, permanent format hint,
 * a length cap — rather than an accident of degradation we hope reads well.
 *
 * The check is the standard one: a browser with native support refuses to store a
 * value that is not a valid date, so the assignment leaves the field empty.
 */
export function supportsDateInput(): boolean {
  if (typeof document === 'undefined') return true

  try {
    const probe = document.createElement('input')
    probe.setAttribute('type', 'date')
    probe.value = 'not-a-date'
    return probe.type === 'date' && probe.value === ''
  } catch {
    return false
  }
}
